import React, { useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { http, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/Kit";

export default function ChangePassword() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (f.new_password !== f.confirm) { toast.error("New passwords do not match"); return; }
    setBusy(true);
    try {
      await http.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e2) { toast.error(apiError(e2.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const field = (key, label, ph) => (
    <div className="mb-4">
      <label className="text-[11px] uppercase tracking-wider text-[#8A8175] font-bold">{label}</label>
      <input type="password" data-testid={`cp-${key}`} value={f[key]} onChange={(e) => setF({ ...f, [key]: e.target.value })} placeholder={ph}
        className="w-full mt-1 border border-[#E7D9C6] rounded-lg px-3.5 py-2.5 text-sm focus:outline-none focus:border-[#A5300F]" />
    </div>
  );

  return (
    <div className="p-6 max-w-xl mx-auto fade-up" data-testid="change-password-view">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: "#FFF5EB" }}><KeyRound className="w-5 h-5 text-[#A5300F]" /></div>
        <div>
          <h1 className="font-display text-3xl font-bold text-[#A5300F]">Account Security</h1>
          <p className="text-sm text-[#8A8175]">{user?.email}</p>
        </div>
      </div>

      <Card className="p-4 mb-5 flex items-center gap-3">
        <ShieldCheck className="w-5 h-5 text-[#2E7D32]" />
        <div className="text-sm text-[#5C554C]">
          Multi-factor authentication is <span className="font-bold text-[#2E7D32]">{user?.mfa_enabled ? "enabled" : "not set up"}</span> on this account.
        </div>
      </Card>

      <Card className="p-6">
        <h2 className="font-display text-xl font-bold text-[#323232] mb-4">Change password</h2>
        <form onSubmit={submit}>
          {field("current_password", "Current password", "••••••••")}
          {field("new_password", "New password", "At least 8 characters")}
          {field("confirm", "Confirm new password", "Re-enter new password")}
          <button type="submit" disabled={busy || !f.current_password || !f.new_password} data-testid="cp-submit"
            className="bg-[#A5300F] text-white font-semibold px-5 py-2.5 rounded-lg hover:bg-[#8F2A0D] disabled:opacity-50">
            {busy ? "Updating…" : "Update password"}
          </button>
        </form>
      </Card>
    </div>
  );
}
